// Index corresponds to number of outfield players - 1
export const formations = {
    3: ['1-2-1', '2-1-1', '1-1-2'],  // 4-a-side
    4: ['1-2-2', '2-2-1', '1-3-1', '2-1-2', '1-1-3', '3-1-1'],  // 5-a-side
    5: ['2-2-2', '2-3-1', '1-3-2', '2-1-3', '1-2-3', '3-1-2', '2-4-1'],  // 6-a-side
    6: ['2-3-2', '3-2-2', '2-2-3', '3-3-1', '1-3-3'],  // 7-a-side
    7: ['3-3-2', '3-2-3', '2-3-3', '2-4-2'],  // 8-a-side
    8: ['3-3-3', '3-4-2', '4-3-2', '4-2-3', '3-2-4', '2-4-3', '2-3-4'],  // 9-a-side
    10: ['4-4-2', '4-3-3', '4-2-3-1', '3-5-2', '3-4-3', '5-3-2', '4-5-1']  // 11-a-side
}; 

// Update to include defaults for different team sizes
export const defaultFormations = {
    // 4v4 defaults (3 outfield players per team)
    3: ['1-2-1', '2-1-1', '1-1-2'],
    // 5v5 defaults (4 outfield players per team)
    4: ['1-2-2', '2-2-1', '1-3-1'],
    // 6v6 defaults (5 outfield players per team)
    5: ['2-2-2', '2-3-1', '1-3-2', '2-4-1'],
    // 7v7 defaults (6 outfield players per team)
    6: ['2-3-2', '3-2-2', '2-2-3'],
    // 8v8 defaults (7 outfield players per team)
    7: ['3-3-2', '3-2-3', '2-3-3'],
    // 9v9 defaults (8 outfield players per team)
    8: ['3-3-3', '3-4-2', '4-3-2'],
    // 11v11 defaults (10 outfield players per team)
    10: ['4-4-2', '4-3-3', '4-2-3-1', '3-5-2'],
    // Fallback to 6v6 formations
    default: ['2-2-2', '2-3-1', '1-3-2']
};

// Add position mappings for each formation
export const formationPositions = {
    // 4-a-side formations (4 outfield players)
    '1-2-1': {
        forward: { top: 25, left: 50 },
        midfield: [
            { top: 45, left: 35 },
            { top: 45, left: 65 }
        ],
        defense: { top: 65, left: 50 }
    },
    '2-1-1': {
        forward: { top: 25, left: 50 },
        midfield: { top: 45, left: 50 },
        defense: [
            { top: 65, left: 35 },
            { top: 65, left: 65 }
        ]
    },
    '1-1-2': {
        forward: [
            { top: 25, left: 35 },
            { top: 25, left: 65 }
        ],
        midfield: { top: 45, left: 50 },
        defense: { top: 65, left: 50 }
    },

    // 5-a-side formations (5 outfield players)
    '1-2-2': {
        forward: [
            { top: 25, left: 40 },
            { top: 25, left: 60 }
        ],
        midfield: [
            { top: 45, left: 35 },
            { top: 45, left: 65 }
        ],
        defense: { top: 65, left: 50 }
    },
    '2-2-1': {
        forward: { top: 25, left: 50 },
        midfield: [
            { top: 45, left: 30 },
            { top: 45, left: 70 }
        ],
        defense: [
            { top: 65, left: 30 },
            { top: 65, left: 70 }
        ]
    },
    '1-3-1': {
        forward: { top: 25, left: 50 },
        midfield: [
            { top: 45, left: 25 },
            { top: 45, left: 50 },
            { top: 45, left: 75 }
        ],
        defense: { top: 65, left: 50 }
    },
    '2-1-2': {
        forward: [
            { top: 25, left: 40 },
            { top: 25, left: 60 }
        ],
        midfield: { top: 45, left: 50 },
        defense: [
            { top: 65, left: 30 },
            { top: 65, left: 70 }
        ]
    },
    '1-1-3': {
        forward: [
            { top: 25, left: 25 },
            { top: 25, left: 50 },
            { top: 25, left: 75 }
        ],
        midfield: { top: 45, left: 50 },
        defense: { top: 65, left: 50 }
    },
    '3-1-1': {
        forward: { top: 25, left: 50 },
        midfield: { top: 45, left: 50 },
        defense: [
            { top: 65, left: 25 },
            { top: 65, left: 50 },
            { top: 65, left: 75 }
        ]
    },

    // 6-a-side formations (6 outfield players)
    '2-3-1': {
        forward: { top: 25, left: 50 },
        midfield: [
            { top: 45, left: 25 },
            { top: 45, left: 50 },
            { top: 45, left: 75 }
        ],
        defense: [
            { top: 65, left: 35 },
            { top: 65, left: 65 }
        ]
    },
    '2-4-1': {
        forward: { top: 25, left: 50 },
        midfield: [
            { top: 45, left: 20 },  // far left
            { top: 45, left: 40 },  // center-left
            { top: 45, left: 60 },  // center-right
            { top: 45, left: 80 }   // far right
        ],
        defense: [
            { top: 65, left: 35 },
            { top: 65, left: 65 }
        ]
    },
    '2-2-2': {
        forward: [
            { top: 25, left: 40 },
            { top: 25, left: 60 }
        ],
        midfield: [
            { top: 45, left: 30 },
            { top: 45, left: 70 }
        ],
        defense: [
            { top: 65, left: 30 },
            { top: 65, left: 70 }
        ]
    },
    '1-3-2': {
        forward: [
            { top: 25, left: 40 },
            { top: 25, left: 60 }
        ],
        midfield: [
            { top: 45, left: 25 },
            { top: 45, left: 50 },
            { top: 45, left: 75 }
        ],
        defense: { top: 65, left: 50 }
    },
    '2-1-3': {
        defense: [  // 2 defenders at back
            { top: 65, left: 35 },
            { top: 65, left: 65 }
        ],
        midfield: [  // 1 midfielder in middle
            { top: 45, left: 50 }
        ],
        forward: [  // 3 forwards up front
            { top: 25, left: 25 },
            { top: 25, left: 50 },
            { top: 25, left: 75 }
        ]
    },
    '1-2-3': {
        forward: [
            { top: 25, left: 25 },
            { top: 25, left: 50 },
            { top: 25, left: 75 }
        ],
        midfield: [
            { top: 45, left: 35 },
            { top: 45, left: 65 }
        ],
        defense: { top: 65, left: 50 }
    },
    '3-1-2': {
        forward: [
            { top: 25, left: 30 },
            { top: 25, left: 70 }
        ],
        midfield: { top: 45, left: 50 },
        defense: [
            { top: 65, left: 25 },
            { top: 65, left: 50 },
            { top: 65, left: 75 }
        ]
    },

    // 7-a-side formations (7 outfield players)
    '3-2-3': {
        forward: [
            { top: 25, left: 25 },
            { top: 25, left: 50 },
            { top: 25, left: 75 }
        ],
        midfield: [
            { top: 45, left: 35 },
            { top: 45, left: 65 }
        ],
        defense: [
            { top: 65, left: 25 },
            { top: 65, left: 50 },
            { top: 65, left: 75 }
        ]
    },
    '3-3-2': {
        forward: [
            { top: 25, left: 30 },
            { top: 25, left: 70 }
        ],
        midfield: [
            { top: 45, left: 25 },
            { top: 45, left: 50 },
            { top: 45, left: 75 }
        ],
        defense: [
            { top: 65, left: 25 },
            { top: 65, left: 50 },
            { top: 65, left: 75 }
        ]
    },
    '2-3-3': {
        forward: [
            { top: 25, left: 25 },
            { top: 25, left: 50 },
            { top: 25, left: 75 }
        ],
        midfield: [
            { top: 45, left: 25 },
            { top: 45, left: 50 },
            { top: 45, left: 75 }
        ],
        defense: [
            { top: 65, left: 30 },
            { top: 65, left: 70 }
        ]
    },
    '2-4-2': {
        forward: [
            { top: 25, left: 40 },
            { top: 25, left: 60 }
        ],
        midfield: [
            { top: 45, left: 25 },  // left
            { top: 45, left: 42 },  // center-left
            { top: 45, left: 58 },  // center-right
            { top: 45, left: 75 }   // right
        ],
        defense: [
            { top: 65, left: 30 },
            { top: 65, left: 70 }
        ]
    },
    '2-3-2': {
        forward: [
            { top: 25, left: 40 },
            { top: 25, left: 60 }
        ],
        midfield: [
            { top: 45, left: 25 }, 
            { top: 45, left: 50 },
            { top: 45, left: 75 }
        ],
        defense: [
            { top: 65, left: 30 },
            { top: 65, left: 70 }
        ]
    },
    '3-2-2': {
        forward: [
            { top: 25, left: 40 },
            { top: 25, left: 60 }
        ],
        midfield: [
            { top: 45, left: 30 },
            { top: 45, left: 70 }
        ],
        defense: [
            { top: 65, left: 25 },
            { top: 65, left: 50 },
            { top: 65, left: 75 }
        ]
    },
    '2-2-3': {
        forward: [
            { top: 25, left: 25 },
            { top: 25, left: 50 },
            { top: 25, left: 75 }
        ],
        midfield: [
            { top: 45, left: 30 },
            { top: 45, left: 70 }
        ],
        defense: [
            { top: 65, left: 30 },
            { top: 65, left: 70 }
        ]
    },
    '3-3-1': {
        forward: { top: 25, left: 50 },
        midfield: [
            { top: 45, left: 25 },
            { top: 45, left: 50 },
            { top: 45, left: 75 }
        ],
        defense: [
            { top: 65, left: 25 },
            { top: 65, left: 50 },
            { top: 65, left: 75 }
        ]
    },
    '1-3-3': {
        forward: [
            { top: 25, left: 25 },
            { top: 25, left: 50 },
            { top: 25, left: 75 }
        ],
        midfield: [
            { top: 45, left: 25 },
            { top: 45, left: 50 },
            { top: 45, left: 75 }
        ],
        defense: { top: 65, left: 50 }
    },

    // 9-a-side formations (8 outfield players per team)
    '3-3-3': {
        forward: [
            { top: 25, left: 25 },  // left
            { top: 25, left: 50 },  // center
            { top: 25, left: 75 }   // right
        ],
        midfield: [
            { top: 45, left: 25 },  // left
            { top: 45, left: 50 },  // center
            { top: 45, left: 75 }   // right
        ],
        defense: [
            { top: 65, left: 25 },  // left
            { top: 65, left: 50 },  // center
            { top: 65, left: 75 }   // right
        ]
    },
    '3-4-2': {
        forward: [
            { top: 25, left: 40 },  // left forward
            { top: 25, left: 60 }   // right forward
        ],
        midfield: [
            { top: 45, left: 25 },  // left
            { top: 45, left: 42 },  // center-left
            { top: 45, left: 58 },  // center-right
            { top: 45, left: 75 }   // right
        ],
        defense: [
            { top: 65, left: 25 },
            { top: 65, left: 50 },
            { top: 65, left: 75 }
        ]
    },
    '4-3-2': {
        forward: [
            { top: 25, left: 40 },
            { top: 25, left: 60 }
        ],
        midfield: [
            { top: 45, left: 25 },
            { top: 45, left: 50 },
            { top: 45, left: 75 }
        ],
        defense: [
            { top: 65, left: 25 },  // left
            { top: 65, left: 42 },  // center-left
            { top: 65, left: 58 },  // center-right
            { top: 65, left: 75 }   // right
        ]
    },
    '4-2-3': {
        forward: [
            { top: 25, left: 25 },
            { top: 25, left: 50 },
            { top: 25, left: 75 }
        ],
        midfield: [
            { top: 45, left: 30 },
            { top: 45, left: 70 }
        ],
        defense: [
            { top: 65, left: 25 },  // left
            { top: 65, left: 42 },  // center-left
            { top: 65, left: 58 },  // center-right
            { top: 65, left: 75 }   // right
        ]
    },
    '3-2-4': {
        forward: [
            { top: 25, left: 25 },  // left
            { top: 25, left: 42 },  // center-left
            { top: 25, left: 58 },  // center-right
            { top: 25, left: 75 }   // right
        ],
        midfield: [
            { top: 45, left: 30 },
            { top: 45, left: 70 }
        ],
        defense: [
            { top: 65, left: 25 },
            { top: 65, left: 50 },
            { top: 65, left: 75 }
        ]
    },
    '2-4-3': {
        forward: [
            { top: 25, left: 25 },  // left
            { top: 25, left: 50 },  // center
            { top: 25, left: 75 }   // right
        ],
        midfield: [
            { top: 45, left: 20 },  // left
            { top: 45, left: 40 },  // center-left
            { top: 45, left: 60 },  // center-right
            { top: 45, left: 80 }   // right
        ],
        defense: [
            { top: 65, left: 30 },
            { top: 65, left: 70 }
        ]
    },
    '2-3-4': {
        forward: [
            { top: 25, left: 25 },  // left
            { top: 25, left: 42 },  // center-left
            { top: 25, left: 58 },  // center-right
            { top: 25, left: 75 }   // right
        ],
        midfield: [
            { top: 45, left: 25 },
            { top: 45, left: 50 },
            { top: 45, left: 75 }
        ],
        defense: [
            { top: 65, left: 30 },
            { top: 65, left: 70 }
        ]
    },

    // 11-a-side formations (11 players including GK)
    '4-4-2': {
        forward: [
            { top: 30, left: 40 },
            { top: 30, left: 60 }
        ],
        midfield: [
            { top: 45, left: 20 },
            { top: 45, left: 40 },
            { top: 45, left: 60 },
            { top: 45, left: 80 }
        ],
        defense: [
            { top: 60, left: 20 },
            { top: 60, left: 40 },
            { top: 60, left: 60 },
            { top: 60, left: 80 }
        ],
        goalkeeper: { top: 75, left: 50 }
    },
    '4-3-3': {
        forward: [
            { top: 30, left: 25 },
            { top: 30, left: 50 },
            { top: 30, left: 75 }
        ],
        midfield: [
            { top: 45, left: 30 },
            { top: 45, left: 50 },
            { top: 45, left: 70 }
        ],
        defense: [
            { top: 60, left: 20 },
            { top: 60, left: 40 },
            { top: 60, left: 60 },
            { top: 60, left: 80 }
        ],
        goalkeeper: { top: 75, left: 50 }
    },
    '4-2-3-1': {
        forward: [
            { top: 40, left: 50 }  // Single striker positioned higher
        ],
        midfield: [
            // The "3" in attacking midfield positions spread across the field
            { top: 35, left: 25 },  // Left attacking midfielder
            { top: 35, left: 50 },  // Central attacking midfielder
            { top: 35, left: 75 },  // Right attacking midfielder
            // The "2" in defensive midfield positions - with a different top value
            { top: 50, left: 35 },  // Left defensive midfielder (changed to a deeper position)
            { top: 50, left: 65 }   // Right defensive midfielder (changed to a deeper position)
        ],
        defense: [
            { top: 65, left: 20 },  // Left back
            { top: 65, left: 40 },  // Left center back
            { top: 65, left: 60 },  // Right center back
            { top: 65, left: 80 }   // Right back
        ],
        goalkeeper: { top: 75, left: 50 }
    },
    '3-5-2': {
        forward: [
            { top: 25, left: 40 },
            { top: 25, left: 60 }
        ],
        midfield: [
            { top: 45, left: 20 },
            { top: 45, left: 35 },
            { top: 45, left: 50 },
            { top: 45, left: 65 },
            { top: 45, left: 80 }
        ],
        defense: [
            { top: 60, left: 30 },
            { top: 60, left: 50 },
            { top: 60, left: 70 }
        ],
        goalkeeper: { top: 75, left: 50 }
    },
    '3-4-3': {
        forward: [
            { top: 25, left: 25 },
            { top: 25, left: 50 },
            { top: 25, left: 75 }
        ],
        midfield: [
            { top: 45, left: 20 },
            { top: 45, left: 40 },
            { top: 45, left: 60 },
            { top: 45, left: 80 }
        ],
        defense: [
            { top: 60, left: 30 },
            { top: 60, left: 50 },
            { top: 60, left: 70 }
        ],
        goalkeeper: { top: 75, left: 50 }
    },
    '5-3-2': {
        forward: [
            { top: 25, left: 40 },
            { top: 25, left: 60 }
        ],
        midfield: [
            { top: 45, left: 30 },
            { top: 45, left: 50 },
            { top: 45, left: 70 }
        ],
        defense: [
            { top: 60, left: 15 },
            { top: 60, left: 30 },
            { top: 60, left: 50 },
            { top: 60, left: 70 },
            { top: 60, left: 85 }
        ],
        goalkeeper: { top: 75, left: 50 }
    },
    '4-5-1': {
        forward: [
            { top: 25, left: 50 }
        ],
        midfield: [
            { top: 45, left: 15 },
            { top: 45, left: 30 },
            { top: 45, left: 50 },
            { top: 45, left: 70 },
            { top: 45, left: 85 }
        ],
        defense: [
            { top: 60, left: 20 },
            { top: 60, left: 40 },
            { top: 60, left: 60 },
            { top: 60, left: 80 }
        ],
        goalkeeper: { top: 75, left: 50 }
    },
}; 

// Add formation transition mappings
export const formationTransitions = {
    // 4-a-side formation transitions
    '1-2-1': {
        '2-1-1': {
            from: { line: 'midfield', index: 1 },
            to: { line: 'defense', index: 1 }
        },
        '1-1-2': {
            from: { line: 'midfield', index: 1 },
            to: { line: 'forward', index: 1 }
        }
    },
    '2-1-1': {
        '1-2-1': {
            from: { line: 'defense', index: 1 },
            to: { line: 'midfield', index: 1 }
        },
        '1-1-2': {
            from: { line: 'defense', index: 1 },
            to: { line: 'forward', index: 1 }
        }
    },
    '1-1-2': {
        '1-2-1': {
            from: { line: 'forward', index: 1 },
            to: { line: 'midfield', index: 1 }
        },
        '2-1-1': {
            from: { line: 'forward', index: 1 },
            to: { line: 'defense', index: 1 }
        }
    },
    
    // Existing 6-a-side formation transitions
    '2-3-1': {
        '2-2-2': {
            // When changing from 2-3-1 to 2-2-2
            // Move one midfielder to forward
            from: { line: 'midfield', index: 2 },  // Take the last midfielder
            to: { line: 'forward', index: 1 }      // Add as second forward
        },
        '1-3-2': {
            // When changing from 2-3-1 to 1-3-2
            // Move one defender to forward
            from: { line: 'defense', index: 1 },  // Take the second defender
            to: { line: 'forward', index: 1 }     // Add as second forward
        },
        '2-4-1': {
            // When changing from 2-3-1 to 2-4-1
            // Add a midfielder
            from: { line: 'midfield', index: 2 },  // Reference position (center midfielder)
            to: { line: 'midfield', index: 3 }     // Add as fourth midfielder
        }
    },
    '2-2-2': {
        '2-3-1': {
            // When changing from 2-2-2 to 2-3-1
            // Move one forward to midfield
            from: { line: 'forward', index: 1 },   // Take the second forward
            to: { line: 'midfield', index: 2 }     // Add as third midfielder
        },
        '1-3-2': {
            // When changing from 2-2-2 to 1-3-2
            // Move one defender to midfield
            from: { line: 'defense', index: 1 },   // Take the second defender
            to: { line: 'midfield', index: 2 }     // Add as third midfielder
        }
    },
    '1-3-2': {
        '2-3-1': {
            // When changing from 1-3-2 to 2-3-1
            // Move one forward to defense
            from: { line: 'forward', index: 1 },   // Take the second forward
            to: { line: 'defense', index: 1 }      // Add as second defender
        },
        '2-2-2': {
            // When changing from 1-3-2 to 2-2-2
            // Move one midfielder to defense
            from: { line: 'midfield', index: 2 },  // Take the third midfielder
            to: { line: 'defense', index: 1 }      // Add as second defender
        }
    },
    // Add transitions for 2-4-1
    '2-4-1': {
        '2-3-1': {
            // When changing from 2-4-1 to 2-3-1
            // Remove one midfielder
            from: { line: 'midfield', index: 3 },  // Remove the last midfielder
            to: { line: 'midfield', index: 2 }     // Maintain reference to center midfielder
        },
        '2-2-2': {
            // When changing from 2-4-1 to 2-2-2
            // Move two midfielders to forward
            from: { line: 'midfield', index: 3 },  // Remove the last midfielder
            to: { line: 'forward', index: 1 }      // Add as second forward
        }
    },
    
    // 9v9 formation transitions
    '3-3-3': {
        '3-4-2': {
            from: { line: 'forward', index: 2 },
            to: { line: 'midfield', index: 3 }
        },
        '4-3-2': {
            from: { line: 'forward', index: 2 },
            to: { line: 'defense', index: 3 }
        }
    },
    '3-4-2': {
        '3-3-3': {
            from: { line: 'midfield', index: 3 },
            to: { line: 'forward', index: 2 }
        },
        '4-3-2': {
            from: { line: 'midfield', index: 3 },
            to: { line: 'defense', index: 3 }
        }
    },
    '4-3-2': {
        '3-3-3': {
            from: { line: 'defense', index: 3 },
            to: { line: 'forward', index: 2 }
        },
        '3-4-2': {
            from: { line: 'defense', index: 3 },
            to: { line: 'midfield', index: 3 }
        },
        '4-2-3': {
            from: { line: 'midfield', index: 2 },
            to: { line: 'forward', index: 2 }
        }
    },
    '4-2-3': {
        '4-3-2': {
            from: { line: 'forward', index: 2 },
            to: { line: 'midfield', index: 2 }
        },
        '3-2-4': {
            from: { line: 'defense', index: 3 },
            to: { line: 'forward', index: 3 }
        }
    },
    '3-2-4': {
        '4-2-3': {
            from: { line: 'forward', index: 3 },
            to: { line: 'defense', index: 3 }
        },
        '2-3-4': {
            from: { line: 'defense', index: 2 },
            to: { line: 'midfield', index: 2 }
        }
    },
    '2-4-3': {
        '2-3-4': {
            from: { line: 'midfield', index: 3 },
            to: { line: 'forward', index: 3 }
        },
        '3-4-2': {
            from: { line: 'forward', index: 2 },
            to: { line: 'defense', index: 2 }
        }
    },
    '2-3-4': {
        '2-4-3': {
            from: { line: 'forward', index: 3 },
            to: { line: 'midfield', index: 3 }
        },
        '3-2-4': {
            from: { line: 'midfield', index: 2 },
            to: { line: 'defense', index: 2 }
        }
    },
    
    // 7-a-side formations transitions
    '3-2-3': {
        '3-3-2': { forward: [0, 1, 2], midfield: [0, 1], defense: [0, 1, 2] },
        '2-3-3': { forward: [0, 1, 2], midfield: [0, 1], defense: [0, 1, 2] },
        '2-4-2': { forward: [0, 1, 2], midfield: [0, 1], defense: [0, 1, 2] },
    },
    '3-3-2': {
        '3-2-3': { forward: [0, 1], midfield: [0, 1, 2], defense: [0, 1, 2] },
        '2-3-3': { forward: [0, 1], midfield: [0, 1, 2], defense: [0, 1, 2] },
        '2-4-2': { forward: [0, 1], midfield: [0, 1, 2], defense: [0, 1, 2] },
    },
    '2-3-3': {
        '3-2-3': { forward: [0, 1, 2], midfield: [0, 1, 2], defense: [0, 1] },
        '3-3-2': { forward: [0, 1, 2], midfield: [0, 1, 2], defense: [0, 1] },
        '2-4-2': { forward: [0, 1, 2], midfield: [0, 1, 2], defense: [0, 1] },
    },
    '2-4-2': {
        '3-2-3': { forward: [0, 1], midfield: [0, 1, 2, 3], defense: [0, 1] },
        '3-3-2': { forward: [0, 1], midfield: [0, 1, 2, 3], defense: [0, 1] },
        '2-3-3': { forward: [0, 1], midfield: [0, 1, 2, 3], defense: [0, 1] },
    },
    
    // 11-a-side formations transitions
    '4-4-2': {
        '4-3-3': { forward: [0, 1], midfield: [0, 1, 2, 3], defense: [0, 1, 2, 3] },
        '4-2-3-1': { forward: [0, 1], midfield: [0, 1, 2, 3], defense: [0, 1, 2, 3] },
        '3-5-2': { forward: [0, 1], midfield: [0, 1, 2, 3], defense: [0, 1, 2, 3] },
    },
    '4-3-3': {
        '4-4-2': { forward: [0, 1, 2], midfield: [0, 1, 2], defense: [0, 1, 2, 3] },
        '4-2-3-1': { forward: [0, 1, 2], midfield: [0, 1, 2], defense: [0, 1, 2, 3] },
        '3-5-2': { forward: [0, 1, 2], midfield: [0, 1, 2], defense: [0, 1, 2, 3] },
    },
    '4-2-3-1': {
        '4-4-2': { forward: [0], midfield: [0, 1, 2, 3, 4], defense: [0, 1, 2, 3] },
        '4-3-3': { forward: [0], midfield: [0, 1, 2, 3, 4], defense: [0, 1, 2, 3] },
        '3-5-2': { forward: [0], midfield: [0, 1, 2, 3, 4], defense: [0, 1, 2, 3] },
    },
    '3-5-2': {
        '4-4-2': { forward: [0, 1], midfield: [0, 1, 2, 3, 4], defense: [0, 1, 2] },
        '4-3-3': { forward: [0, 1], midfield: [0, 1, 2, 3, 4], defense: [0, 1, 2] },
        '4-2-3-1': { forward: [0, 1], midfield: [0, 1, 2, 3, 4], defense: [0, 1, 2] },
    },
    '3-4-3': {
        '4-4-2': { forward: [0, 1, 2], midfield: [0, 1, 2, 3], defense: [0, 1, 2] },
        '4-3-3': { forward: [0, 1, 2], midfield: [0, 1, 2, 3], defense: [0, 1, 2] },
        '3-5-2': { forward: [0, 1, 2], midfield: [0, 1, 2, 3], defense: [0, 1, 2] },
    },
    '5-3-2': {
        '4-4-2': { forward: [0, 1], midfield: [0, 1, 2], defense: [0, 1, 2, 3, 4] },
        '4-3-3': { forward: [0, 1], midfield: [0, 1, 2], defense: [0, 1, 2, 3, 4] },
        '3-5-2': { forward: [0, 1], midfield: [0, 1, 2], defense: [0, 1, 2, 3, 4] },
    },
    '4-5-1': {
        '4-4-2': { forward: [0], midfield: [0, 1, 2, 3, 4], defense: [0, 1, 2, 3] },
        '4-3-3': { forward: [0], midfield: [0, 1, 2, 3, 4], defense: [0, 1, 2, 3] },
        '3-5-2': { forward: [0], midfield: [0, 1, 2, 3, 4], defense: [0, 1, 2, 3] },
    }
}; 